import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { RetrievePasswordComponent } from 'src/app/shared/components/retrieve-password/retrieve-password.component';
import { ChangerMotDePasseComponent } from 'src/app/shared/components/changer-mot-de-passe/changer-mot-de-passe.component';
import { ForgotPasswordComponent } from 'src/app/shared/components/forgot-password/forgot-password.component';
import { LoginComponent } from 'src/app/shared/components/login/login/login.component';
import { LogoutComponent } from 'src/app/shared/components/logout/logout.component';
import { AccueilComponent } from 'src/app/user/components/accueil/accueil.component';
import { CataloguesComponent } from 'src/app/user/components/catalogues/catalogues.component';
import { DetailCatalogueComponent } from 'src/app/user/components/detail-catalogue/detail-catalogue.component';
import { AuthGuardService } from 'src/app/shared/core/interceptors/auth-guard.service';
import { GeneralDynamicContentComponent } from 'src/app/shared/components/general-dynamic-content/general-dynamic-content.component';
import { ContactComponent } from 'src/app/shared/components/contact/contact.component';
import { ResourceFileRedirectComponent } from 'src/app/shared/components/resource-file-redirect/resource-file-redirect.component';

export const PATHS = {
  login: 'login',
  logout: 'logout',
  admin: 'admin',
  customID: ':id',
  //
  home: 'accueil',
  home_en: 'home',
  home_fr: 'accueil',
  home_es: 'inicio',
  home_de: 'startseite',
  //
  catalogue: 'catalogue',
  catalogue_en: 'catalog',
  catalogue_fr: 'catalogue',
  catalogue_es: 'catalogo',
  catalogue_de: 'katalog',
  //
  product: 'produit',
  product_en: 'product',
  product_fr: 'produit',
  product_es: 'producto',
  product_de: 'produkt',
  //
  machines: 'machines',
  machines_en: 'machines',
  machines_fr: 'machines',
  machines_es: 'maquinas',
  machines_de: 'maschinen',
  //
  consumables: 'consommables',
  consumables_en: 'consumables',
  consumables_fr: 'consommables',
  consumables_es: 'consumibles',
  consumables_de: 'verbrauchsmaterialen',
  //
  tools: 'tools',
  tools_en: 'tools',
  tools_fr: 'outillage',
  tools_es: 'herramientas',
  tools_de: 'werkzeuge',
  //
  technologies: 'technologies',
  technologies_en: 'technologies',
  technologies_fr: 'technologies',
  technologies_es: 'tecnologias',
  technologies_de: 'technologien',
  //
  company: 'societe',
  company_en: 'company',
  company_fr: 'societe',
  company_es: 'empresa',
  company_de: 'geschaft',
  //
  news: 'actualites',
  news_en: 'news',
  news_fr: 'actualites',
  news_es: 'noticias',
  news_de: 'neuigkeiten',
  //
  external_download: 'befor-resources',
  contact: 'contact',
  contact_en: 'contact',
  contact_fr: 'contact',
  contact_es: 'contacto',
  contact_de: 'kontakt',
  //
  account: 'mon-compte',
  devis: 'devis',
  favorite: 'favoris',
  forgot: 'forgot-password',
  retrieve: 'retrievepassword/reset',
  //
  modifyPassword: 'changer-mot-de-passe',
  fournisseur: 'fournisseur',
  monEspace: 'espace',
  monCatalogue: 'catalogue',
  monEurochef: 'catalogue-eurochef',
  suppliers: 'fournisseurs',
  bibliotheque: 'biblo',
  gestion: 'gestion',
  gestion_article: 'articles',
  gestion_fournisseurs: 'fournisseurs',
  gestion_marques: 'marques',
  gestion_associe: 'associe',
  gestion_clients: 'clients',
  categorie: 'categorie',
  associates: 'associes',
  roles: 'roles',
  projectOverview: 'project-overview',
  projectDetail: 'project-detail',
  resourceFilesRedirect: 'resource-files-redirect',
  mesFavoris: 'mes-favoris',
};

export const OGPATHS = {
  home: 'home',
  catalogue: 'catalogue',
  product: 'product',
  machines: 'machines',
  consumables: 'consumables',
  tools: 'tools',
  technologies: 'technologies',
  company: 'company',
  news: 'news',
  contact: 'contact',
};

const routes: Routes = [
  { path: `${PATHS.admin}/${PATHS.resourceFilesRedirect}/${PATHS.customID}`, component: ResourceFileRedirectComponent },

  { path: '', redirectTo: `fr/${PATHS.home_fr}` },
  { path: '*', redirectTo: `fr/${PATHS.home_fr}` },
  { path: '/', redirectTo: `fr/${PATHS.home_fr}` },
  {
    path: `${PATHS.admin}/${PATHS.customID}`,
    component: DashboardComponent,
    canActivate: [AuthGuardService],
  },
  { path: PATHS.login, component: LoginComponent },
  { path: PATHS.logout, component: LogoutComponent },
  { path: PATHS.forgot, component: ForgotPasswordComponent },
  { path: PATHS.retrieve, component: RetrievePasswordComponent },
  { path: PATHS.modifyPassword, component: ChangerMotDePasseComponent },
  //
  { path: PATHS.home, redirectTo: `fr/${PATHS.home_fr}` },
  { path: `:lang/${PATHS.home_en}`, component: AccueilComponent },
  { path: `:lang/${PATHS.home_fr}`, component: AccueilComponent },
  { path: `:lang/${PATHS.home_es}`, component: AccueilComponent },
  { path: `:lang/${PATHS.home_de}`, component: AccueilComponent },
  //
  {
    path: `${PATHS.catalogue}/${PATHS.machines}/:category`,
    redirectTo: `fr/${PATHS.catalogue_fr}/${PATHS.machines_fr}`,
  },
  {
    path: `:lang/${PATHS.catalogue_en}/${PATHS.machines_en}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_fr}/${PATHS.machines_fr}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_es}/${PATHS.machines_es}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_de}/${PATHS.machines_de}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_en}/${PATHS.machines_en}`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_fr}/${PATHS.machines_fr}`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_es}/${PATHS.machines_es}`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_de}/${PATHS.machines_de}`,
    component: CataloguesComponent,
  },
  //
  {
    path: `${PATHS.catalogue}/${PATHS.consumables}/:category`,
    redirectTo: `fr/${PATHS.catalogue_fr}/${PATHS.consumables_fr}`,
  },
  {
    path: `:lang/${PATHS.catalogue_en}/${PATHS.consumables_en}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_fr}/${PATHS.consumables_fr}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_es}/${PATHS.consumables_es}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_de}/${PATHS.consumables_de}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_en}/${PATHS.consumables_en}`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_fr}/${PATHS.consumables_fr}`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_es}/${PATHS.consumables_es}`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_de}/${PATHS.consumables_de}`,
    component: CataloguesComponent,
  },
  //
  {
    path: `${PATHS.catalogue}/${PATHS.tools}/:category`,
    redirectTo: `fr/${PATHS.catalogue_fr}/${PATHS.tools_fr}`,
  },
  {
    path: `:lang/${PATHS.catalogue_en}/${PATHS.tools_en}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_fr}/${PATHS.tools_fr}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_es}/${PATHS.tools_es}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_de}/${PATHS.tools_de}/:category`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_en}/${PATHS.tools_en}`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_fr}/${PATHS.tools_fr}`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_es}/${PATHS.tools_es}`,
    component: CataloguesComponent,
  },
  {
    path: `:lang/${PATHS.catalogue_de}/${PATHS.tools_de}`,
    component: CataloguesComponent,
  },
  //
  { path: `${PATHS.product}/:ref`, redirectTo: `fr/${PATHS.home_fr}` },
  {
    path: `:lang/${PATHS.product_en}/:ref`,
    component: DetailCatalogueComponent,
  },
  {
    path: `:lang/${PATHS.product_fr}/:ref`,
    component: DetailCatalogueComponent,
  },
  {
    path: `:lang/${PATHS.product_es}/:ref`,
    component: DetailCatalogueComponent,
  },
  {
    path: `:lang/${PATHS.product_de}/:ref`,
    component: DetailCatalogueComponent,
  },
  //
  { path: `${PATHS.technologies}`, redirectTo: `fr/${PATHS.technologies_fr}` },
  {
    path: `:lang/${PATHS.technologies_en}`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.technologies_fr}`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.technologies_es}`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.technologies_de}`,
    component: GeneralDynamicContentComponent,
  },
  //
  { path: `${PATHS.news}`, redirectTo: `fr/${PATHS.news_fr}` },
  { path: `:lang/${PATHS.news_en}`, component: GeneralDynamicContentComponent },
  { path: `:lang/${PATHS.news_fr}`, component: GeneralDynamicContentComponent },
  { path: `:lang/${PATHS.news_es}`, component: GeneralDynamicContentComponent },
  { path: `:lang/${PATHS.news_de}`, component: GeneralDynamicContentComponent },
  //
  { path: `${PATHS.company}`, redirectTo: `fr/${PATHS.company_fr}` },
  {
    path: `:lang/${PATHS.company_en}`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.company_fr}`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.company_es}`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.company_de}`,
    component: GeneralDynamicContentComponent,
  },
  //
  {
    path: `${PATHS.technologies}/:url`,
    redirectTo: `fr/${PATHS.technologies_fr}`,
  },
  {
    path: `:lang/${PATHS.technologies_en}/:url`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.technologies_fr}/:url`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.technologies_es}/:url`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.technologies_de}/:url`,
    component: GeneralDynamicContentComponent,
  },
  //
  { path: `${PATHS.news}/:url`, redirectTo: `fr/${PATHS.news_fr}` },
  {
    path: `:lang/${PATHS.news_en}/:url`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.news_fr}/:url`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.news_es}/:url`,
    component: GeneralDynamicContentComponent,
  },
  {
    path: `:lang/${PATHS.news_de}/:url`,
    component: GeneralDynamicContentComponent,
  },
  //
  { path: `${PATHS.contact}`, redirectTo: `fr/${PATHS.contact_fr}` },
  { path: `:lang/${PATHS.contact_en}`, component: ContactComponent },
  { path: `:lang/${PATHS.contact_fr}`, component: ContactComponent },
  { path: `:lang/${PATHS.contact_es}`, component: ContactComponent },
  { path: `:lang/${PATHS.contact_de}`, component: ContactComponent },
  //
  { path: '**', redirectTo: `fr/${PATHS.home_fr}` },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
